import { render, staticRenderFns } from "./SmsMessagesTab.vue?vue&type=template&id=7ba504a5"
import script from "./SmsMessagesTab.vue?vue&type=script&lang=js"
export * from "./SmsMessagesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports